import React from "react";

const Container = ({ children, className, id = "" }: any) => {
  return (
    <div
      id={`${id}Container`}
      className={`mx-auto max-w-7xl px-6 lg:px-8 ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;
